import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { TenantCard } from "@/components/landlord/TenantCard";

export function BrowseTenantsTab({ filters, setFilters, onApply, tenants, slIds, onShortlist, onViewReport, onOffer }) {
  return (
    <>
      <div className="bg-white border border-border rounded-sm p-4 mb-6 flex flex-wrap gap-3 items-end">
        <div><Label className="text-xs">Min budget</Label><Input data-testid="filter-min" className="w-32" type="number" value={filters.min_budget} onChange={(e) => setFilters({ ...filters, min_budget: e.target.value })} /></div>
        <div><Label className="text-xs">Max budget</Label><Input data-testid="filter-max" className="w-32" type="number" value={filters.max_budget} onChange={(e) => setFilters({ ...filters, max_budget: e.target.value })} /></div>
        <div><Label className="text-xs">Area / city</Label><Input data-testid="filter-area" className="w-40" value={filters.area} onChange={(e) => setFilters({ ...filters, area: e.target.value })} /></div>
        <div><Label className="text-xs">Near address</Label><Input data-testid="filter-address" className="w-52" value={filters.origin_address} onChange={(e) => setFilters({ ...filters, origin_address: e.target.value })} placeholder="Property address" /></div>
        <div>
          <Label className="text-xs">Within</Label>
          <select data-testid="filter-radius" value={filters.radius_miles} onChange={(e) => setFilters({ ...filters, radius_miles: e.target.value })}
            className="w-28 h-10 rounded-sm border border-input bg-background px-2 text-sm">
            {[5, 10, 25, 50, 100].map((m) => (<option key={m} value={m}>{m} mi</option>))}
          </select>
        </div>
        <Button data-testid="filter-apply" onClick={onApply}>Apply</Button>
      </div>
      {tenants.length === 0 ? (
        <div className="bg-white border border-border rounded-sm p-12 text-center text-muted-foreground">No verified active tenants match your filters yet.</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {tenants.map((t) => (<TenantCard key={t.user_id} t={t} shortlisted={slIds.has(t.user_id)} onShortlist={onShortlist} onViewReport={onViewReport} onOffer={onOffer} />))}
        </div>
      )}
    </>
  );
}
